/*
 * @Author: edvardchen
 * @Date:   2017-02-09 15:43:12
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2017-02-09 15:49:51
 */

export default function str2bool(str) {
  return Boolean(str && str !== 'false' && str !== '0');
}
